<template>
  <div class="UploadPresentation">

    <presentation-breadcrumbs :items="[{text: 'Upload'}]">
    </presentation-breadcrumbs>

    <presentation-toolbar :presentation="presentation">
    </presentation-toolbar>

    <v-form @submit.prevent="submit"
            ref="form"
            :disabled="form.busy">
      <v-card class="mb-4">

        <v-card-text>
          <v-file-input v-model="form.file"
                        clearable
                        :accept="accept"
                        :loading="form.busy"
                        :placeholder="`Upload a new version of ${DOMPurify.sanitize(this.presentation.name)}`"
                        show-size
                        :prepend-icon="icon"
                        :truncate-length="155"
                        :rules="[rules.required]"
                        :error-messages="form.errors.get('file')">
          </v-file-input>

          <v-progress-linear :value="progressValue"
                             v-if="form.busy && progress"
                             height="8">
          </v-progress-linear>

        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Upload
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-form>

  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import presentationService from '../../../../ml/services/presentationService';
import formValidation from '../../plugins/formValidation';
import DOMPurify from 'dompurify';

export default {
  mixins: [formValidation],
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        file: null,
      }),
      progress: null,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    accept() {
      return 'application/pdf';
    },
    icon() {
      return presentationService.getIcon((this.presentation.presentation_type), 'fal fa-paperclip');
    },
    progressValue() {
      // @see https://developer.mozilla.org/en-US/docs/Web/API/ProgressEvent
      if (this.progress && this.progress.lengthComputable && this.progress.total) {
        return (this.progress.loaded / this.progress.total) * 100;
      }
      return null;
    }
  },
  created() {

  },
  methods: {
    DOMPurify,
    async submit() {
      if (this.form.busy) {
        return;
      }
      if (!this.$refs.form.validate()) {
        return;
      }
      const fileList = this.form.file;
      console.log(fileList.name);
      for (let i = 0, numFiles = fileList.length; i < numFiles; i++) {
        const file = fileList[i];
        console.log(file.name);
      }
      const formData = new FormData();
      formData.append('file', this.form.file);

      const config = {
        data: formData,
        onUploadProgress: (progress) => {
          this.progress = progress;
          console.log(progress.loaded, progress.total, this.progressValue);
        }
      }
      try {
        console.log('Uploading');
        const {data} = await this.form.post(`/api/presentations/${this.presentation.id}/upload`, config)
        console.log('Uploading Complete');
      } catch (e) {

      } finally {
        this.form.busy = false;
      }
    }
  }
}
</script>
